module.exports = __webpack_public_path__ + "static/media/icon.audio.on.da509867.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon.audio.on.svg
// module id = 256
// module chunks = 0